module.exports = {"id":"215998","name":"Ignacio Fernández","rating":"75","photo":"./data/images/photos/3/215998.png","club":{"name":"River Plate","logo":"./data/images/clubs/RiverPlate.png"},"positions":["MC","MOC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/IgnacioFernandez0.json
// module id = 1779
// module chunks = 0